import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { buildStampImageAlt } from '../api/productos';
import './PosterGrid.css';

export default function PosterGrid({ stamps }) {
  return (
    <>
      <div className="poster-grid-container">
        {stamps.map((poster) => {
          const lastImageIndex = poster.images.length - 1;
          return (
            <div key={poster.id} className="poster-item">
              <Link to={`/personalizar/${poster.slug}`} className="poster-card">
                <img
                  src={poster.images[lastImageIndex]}
                  alt={buildStampImageAlt(poster, lastImageIndex)}
                  className="poster-image"
                  loading="lazy"
                />
              </Link>
              <div className="poster-info">
                <h5>{poster.title}</h5>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

PosterGrid.propTypes = {
  stamps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired,
      images: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ).isRequired,
};
